import axios from "axios";

const domainURL = "https://ly-iphone-store-backend.onrender.com/api";
// const domainURL = "http://localhost:5002/api";

export const ProductService = {
  // [ADMIN]
  getProducts: async (params) => {
    try {
      if (Array.isArray(params.productIds)) {
        params = {
          ...params,
          productIds: params.productIds.join(","),
        };
      }

      const response = await axios.get(`${domainURL}/products/`, { params });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },

  // [ADMIN]
  getAllProducts: async (params) => {
    try {
      const response = await axios.get(
        `${domainURL}/products/all-products`,
        params
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },

  getListProducts: async (params) => {
    try {
      if (!params.page && !params.pageSize) return { Data: null, Status: null };
      if (Array.isArray(params.productIds)) {
        params = {
          ...params,
          productIds: params.productIds.join(","),
        };
      }
      if (Array.isArray(params.category)) {
        params = {
          ...params,
          category: params.category.join(","),
        };
      }

      const response = await axios.get(`${domainURL}/products/get-list`, {
        params,
      });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },

  getProductDetail: async (productSlug) => {
    try {
      const response = await axios.get(`${domainURL}/products/${productSlug}`);
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },
  uploadProductImages: async (formData) => {
    try {
      const response = await axios.post(
        `${domainURL}/products/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },
  addProduct: async (productData) => {
    try {
      const response = await axios.post(`${domainURL}/products/`, productData);
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },
  updateProduct: async (id, updatedProduct) => {
    try {
      const response = await axios.put(
        `${domainURL}/products/${id}`,
        updatedProduct
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },

  // [DELETE]
  deleteProduct: async (id) => {
    try {
      const response = await axios.delete(`${domainURL}/products/${id}`);
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },
  deleteSelectedProducts: async (ids) => {
    try {
      const response = await axios.delete(`${domainURL}/products`, {
        data: { ids }, // Truyền danh sách ID vào body request
      });
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error deleting products:", error);
      return { Data: null, Error: error };
    }
  },

  // [IMPORT]
  importProducts: async (formData) => {
    try {
      const response = await axios.post(
        `${domainURL}/products/import`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response) return { Data: response.data, Status: response.status };
    } catch (error) {
      console.error("Error fetching products:", error);
      return { Data: null, Error: error };
    }
  },
};
